import React, { useEffect, useState } from "react";
import { Button, Grid, TextField } from "@mui/material";
import SoftBox from "components/SoftBox";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import ReactSelect from "react-select"; // Ensure ReactSelect is correctly imported
import toast from "react-hot-toast";
import PrimaryButton from "../../../components/PrimaryButton";

function AddOns() {
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [categoryData, setCategoryData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({ name: "", currency: "" });
  const [editIndex, setEditIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editedState, setEditedState] = useState();

  useEffect(() => {
    async function fetchData() {
      const response = await AppService.saas.fetch_addons({
        query: `agency_id=${agency._id}`,
      });
      setCategoryData(response?.response?.data || []);
    }
    fetchData();
  }, []);

  const handleOpenModal = (index, _id) => {
    setEditedState(_id);
    if (index >= 0) {
      const data = categoryData[index];
      setFormData({ name: data.name, currency: data.currency });
      setEditIndex(index);
    } else {
      setFormData({ name: "", currency: "" });
      setEditIndex(null);
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCurrencyChange = (option) => {
    setFormData((prev) => ({
      ...prev,
      currency: option.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    let payload;

    if (editIndex != null) {
      payload = {
        _id: editedState,
        ...formData,
        agency_id: agency._id,
      };
    } else {
      payload = {
        ...formData,
        agency_id: agency._id,
      };
    }

    let response;
    if (editIndex != null) {
      response = await AppService.saas.edit_addons({ payload });
    } else {
      response = await AppService.saas.addons({ payload });
    }

    if (response) {
      fetchCategories();
      handleCloseModal();
      toast.success("Add Ons created successfully!");
    } else {
      toast.error("Error adding Add Ons");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    const payload = { _id: id };
    const response = await AppService.saas.delete_addons({ payload });
    if (response) {
      fetchCategories();
      toast.success("Add Ons Deleted");
    } else {
      toast.error("Error deleting Add Ons");
    }
    setLoading(false);
  };

  const fetchCategories = async () => {
    const response = await AppService.saas.fetch_addons({
      query: `agency_id=${agency._id}`,
    });
    setCategoryData(response?.response?.data || []);
  };

  return (
    <div>
      <SoftBox component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3} paddingX={3} paddingBottom={4}>
          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <PrimaryButton showPlus type="button" onClick={() => handleOpenModal(-1)}>
              Add On
            </PrimaryButton>
          </Grid>

          <Grid item xs={12}>
            {categoryData.map((category, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                  padding: "10px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <p>{category.name}</p>
                <p>{category.currency}</p>
                <div>
                  <Button
                    variant="contained"
                    style={{ background: "black", color: "white" }}
                    onClick={() => handleOpenModal(index, category._id)}
                    disabled={loading}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleDelete(category._id);
                    }}
                    style={{ background: "black", color: "white", marginLeft: "10px" }}
                    disabled={loading}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            ))}
          </Grid>
        </Grid>

        {openModal && (
          <div className="modal-zz-confirm text-left">
            <div
              className="scrollable-modal-content"
              style={{
                padding: "20px",
                backgroundColor: "white",
                borderRadius: "10px",
                position: "relative",
              }}
            >
              <h2>{editIndex !== null ? "Edit Addons" : "Add Addons"}</h2>
              <span className="crossison" onClick={handleCloseModal}>
                X
              </span>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                margin="normal"
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    width: "100%",
                    paddingRight: 0,
                  },
                  "& .MuiOutlinedInput-input": {
                    width: "100% !important",
                    padding: "12px 0px",
                    boxSizing: "border-box",
                  },
                }}
              />

              <Button
                type="submit"
                variant="contained"
                className="btn-newdezine"
                disabled={loading}
                style={{ background: "black", color: "white", marginTop: "20px", width: "100%" }}
              >
                {loading ? "loading..." : editIndex !== null ? "Update" : "Add"}
              </Button>
            </div>
          </div>
        )}
      </SoftBox>
    </div>
  );
}

export default AddOns;
